import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomIcon from "../../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

function PathPickBasketHeader() {
  const { t, tTitle, tSentence } = useI18nHelper();
  const navigate = useNavigate();

  return (
    // 좁은 폭에서는 제목·설명과 버튼이 한 줄에 들어가지 않아 버튼을 다음 줄로 내린다.
    <Flex
      justifyContent={"space-between"}
      alignItems={"center"}
      flexWrap={"wrap"}
      gap={"8px"}
    >
      <Flex flexDirection={"column"} gap={"2px"}>
        <Text textStyle={"body-lg-bold"}>
          {tTitle("path_pick:basket.title")}
        </Text>
        <Text textStyle={"body-sm-medium"} color={"#8F8F8C"}>
          {tSentence("path_pick:basket.description")}
        </Text>
      </Flex>
      {/* 모바일에서는 GNB로 상품 찾기에 바로 갈 수 있어 돌아가기 버튼을 감춘다.
          AppButton은 Tooltip으로 감싸여 있어 display 분기는 바깥 Flex에 건다. */}
      <Flex display={{ base: "none", md: "flex" }}>
        <AppButton
          variant={"white"}
          onClick={() => navigate("/pathpick/search-products")}
        >
          <Flex gap={"4px"} alignItems={"center"}>
            <CustomIcon
              src={"chevron-left"}
              width={16}
              height={16}
              color={"#444440"}
            />
            <Text textStyle={"body-sm-bold"}>
              {t("path_pick:basket.back_to_path_pick")}
            </Text>
          </Flex>
        </AppButton>
      </Flex>
    </Flex>
  );
}

export default PathPickBasketHeader;
